import ManageAccounts from "@/views/ManageAccounts/ManageAccounts";

export default { ManageAccounts};
